export default __webpack_public_path__ + "static/media/mongoDB.09e04a7a.svg";